export const PASSWORD_POLICY_HINT =
  'Use at least 12 characters with uppercase, lowercase, number, and symbol.';

const COMMON_PASSWORDS = new Set([
  'password',
  'password1',
  'password123',
  '12345678',
  '123456789',
  'qwerty123',
  'letmein',
  'admin123',
]);

export function getPasswordPolicyError(password: string): string | null {
  const candidate = String(password ?? '');
  if (!candidate.trim()) return 'Password is required.';
  if (candidate.length < 12) return PASSWORD_POLICY_HINT;
  if (!/[a-z]/.test(candidate)) return PASSWORD_POLICY_HINT;
  if (!/[A-Z]/.test(candidate)) return PASSWORD_POLICY_HINT;
  if (!/[0-9]/.test(candidate)) return PASSWORD_POLICY_HINT;
  if (!/[^A-Za-z0-9]/.test(candidate)) return PASSWORD_POLICY_HINT;
  if (/\s/.test(candidate)) return 'Password cannot contain spaces.';

  const normalized = candidate.toLowerCase();
  if (normalized.includes('password')) {
    return 'Password cannot contain the word "password".';
  }
  if (COMMON_PASSWORDS.has(normalized)) {
    return 'Password is too common. Choose a stronger password.';
  }
  return null;
}
